import { Reducer } from "redux"
import {
    APICollaborationModel,
    APICollaborationParams,
    getCollaborationID
} from "../../../Models/API/CollaboratorModel"
import { CollaboratorType, AuthUserType } from "../../../Actions/Types"
import { AuthAction } from "../../Auth"
import {
    getInitialData,
    RemoteData,
    setPage,
    setItem,
    markAllPagesOfAllEntriesAsStale
} from "../../../Models/Client/RemoteData"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"
import { updateAt } from "../../../Helpers/Functions/reducer"

export interface CollaboratorState {
    table: {
        [appID: string]:
            | RemoteData<APICollaborationModel, APICollaborationParams, string>
            | undefined
    }
}

interface SetCollaboratorListAction {
    type: CollaboratorType.setProjectCollaborators
    meta: {
        instanceID: string
        page: number
        total: number
        params: APICollaborationParams
    }
    payload: APICollaborationModel[]
}

interface SetCollaboratorAction {
    type: CollaboratorType.setCollaborator
    payload: APICollaborationModel
}

export type CollaboratorAction =
    | SetCollaboratorListAction
    | SetCollaboratorAction

const initialState: CollaboratorState = {
    table: {}
}

export const CollaboratorReducer: Reducer<
    CollaboratorState,
    CollaboratorAction | AuthAction | RouterAction
> = (state = initialState, action): CollaboratorState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                table: markAllPagesOfAllEntriesAsStale(state.table)
            }
        case CollaboratorType.setCollaborator:
            return {
                ...state,
                table: updateAt(state.table, action.payload.appId, data =>
                    setItem(
                        data ?? getInitialData(),
                        String(action.payload.id),
                        action.payload,
                        getCollaborationID
                    )
                )
            }
        case CollaboratorType.setProjectCollaborators:
            return {
                ...state,
                table: updateAt(state.table, action.meta.instanceID, table =>
                    setPage(
                        table ?? getInitialData(),
                        action.meta.params,
                        action.payload,
                        getCollaborationID,
                        action.meta.page,
                        action.meta.total
                    )
                )
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
